import React from 'react';
import  {assets_root, lorem, notes,titles, captions} from './Helpers';
import Chart from './Chart';
import {Divider} from 'semantic-ui-react';
import Context from './Context';

function Content(props) {
  return (
    <Context.Consumer>
     {({width, step, indicator, demographic}) => (
        <div className="App">

          <div className="well" >
            <div className="contain" style={{flexDirection: 'column'}}>
              <div className="sections" style={{width:'100%', marginLeft: 0, marginRight: 0 }}>
                <section data-step='4'>
                <p style={{fontFamily: 'Georgia'}}>Over the years, Pew Research Center has explored the experiences and attitudes of U.S adults from <a href="https://www.pewresearch.org/topics/race-and-ethnicity/">different racial and ethnic groups</a>. As the country continues to diversify along racial and ethnic lines, key indicators of social and economic well-being show that some groups are faring better than others. The charts below allow for comparisons between racial or ethnic groups over time on a range of measures including educational attainment, household income, life expectancy and others. You may select any two groups at a time for comparison.</p>
                </section>
                </div>
                <div className="graphic" style={{width: "100%"}}>

                 <Chart ui={true} demographic={demographic}/>
               </div>
               <div className="caption" dangerouslySetInnerHTML={{ __html: captions[indicator]}} ></div>
               <div class="note" dangerouslySetInnerHTML={{ __html: notes[indicator] }}></div>
          </div>
        </div>

        </div>
      )}
      </Context.Consumer>
  );
}

export default Content;
